exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vux-x-img, .b-lazy {\r\n  -webkit-transition: opacity 500ms ease-in-out;\r\n  transition: opacity 500ms ease-in-out;\r\n  max-width: 100%;\n}\n.b-lazy {\r\n  opacity: 0;\n}\n.b-lazy.b-loaded {\r\n  opacity: 1;\n}\r\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/thomas-zh-88phat-m/node_modules/vux/src/components/x-img/index.vue"],"names":[],"mappings":";AACA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,gBAAgB;CACjB;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ","file":"index.vue","sourcesContent":["\n.vux-x-img, .b-lazy {\r\n  -webkit-transition: opacity 500ms ease-in-out;\r\n  transition: opacity 500ms ease-in-out;\r\n  max-width: 100%;\n}\n.b-lazy {\r\n  opacity: 0;\n}\n.b-lazy.b-loaded {\r\n  opacity: 1;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2866cbf8","scoped":false,"hasInlineConfig":false}!./build/xpx-to-sbrem-loader.js!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vux/src/components/x-img/index.vue
// module id = NMT7
// module chunks = 0 9